module.exports = {"rootPath":"https://www.etelconnections.com","clientid":"doF5nW9DkLvO84EOOGX8gwgPSnxjXcWt","domain":"etelcommunications.auth0.com","redirectUri":"/home","passwordsalt":"9A5938E7FA6D78ADEAD666D4D8D48"}


//////////////////
// WEBPACK FOOTER
// ./src/security/config.json
// module id = 143
// module chunks = 37